import styled from "styled-components";
import { colors, radius, spacing } from "../../utils";

export const AccordionContainer = styled.div`
  border: none;
  border-radius: ${radius.md}px;
  margin-bottom: 10px;
  overflow: hidden;

  & .accordion-summary {
    display: flex;
    justify-content: space-between;
    align-items: center;

    cursor: pointer;
    /* Corner-rounded highlight with a consistent text↔edge margin so the purple
       hover fill is never square or flush against the text. radius.md (8px) +
       spacing.md (12px) are the app's card/row tokens. */
    padding: 10px ${spacing.md}px;
    border-radius: ${radius.md}px;
    background-color: #ffffff;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${colors.Highlight};
    }
  }

  & .accordion-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  & .accordion-details {
    display: none;
  }

  &.expanded .accordion-details {
    display: block;
  }
`;
